/* Douillet — interactions légères (aucune dépendance). Chargé en defer. */
(() => {
  const root = document.documentElement;
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Header : état "scrollé" (ombre douce) ---------- */
  let ticking = false;
  const onScroll = () => {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(() => {
      root.classList.toggle('dl-scrolled', window.scrollY > 12);
      ticking = false;
    });
  };
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  /* ---------- Reveal au scroll (uniquement les sections hors écran au chargement) ---------- */
  if (root.dataset.dlReveal === 'true' && !reduceMotion && 'IntersectionObserver' in window) {
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in');
            io.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
    );
    document.querySelectorAll('main > .shopify-section').forEach((section) => {
      if (section.getBoundingClientRect().top > window.innerHeight * 0.9) {
        section.classList.add('dl-reveal');
        io.observe(section);
      }
    });
  }

  /* ---------- Sélecteur d'offre : pilote la quantité du formulaire natif ---------- */
  const getTierQty = (sectionId) => {
    const checked = document.querySelector(`douillet-offer-tiers[data-section-id="${sectionId}"] input:checked`);
    return checked ? Number(checked.value) : null;
  };

  const applyQty = (sectionId) => {
    const qty = getTierQty(sectionId);
    if (!qty) return;
    const scope = document.getElementById(`shopify-section-${sectionId}`) || document;
    scope.querySelectorAll('product-form-component input[name="quantity"]').forEach((input) => {
      if (String(input.value) === String(qty)) return;
      input.value = String(qty);
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  };

  if (!customElements.get('douillet-offer-tiers')) {
    customElements.define(
      'douillet-offer-tiers',
      class extends HTMLElement {
        connectedCallback() {
          const id = this.dataset.sectionId;
          const section = document.getElementById(`shopify-section-${id}`);
          if (section) section.classList.add('dl-has-tiers');
          this.addEventListener('change', () => applyQty(id));
          requestAnimationFrame(() => applyQty(id));
        }
      }
    );
  }

  // Ré-applique la quantité juste avant tout ajout au panier (bouton principal ou barre sticky),
  // car le formulaire est re-rendu à chaque changement de variante.
  document.addEventListener(
    'click',
    (event) => {
      const button = event.target.closest('button');
      if (!button) return;
      const tiers = document.querySelector('douillet-offer-tiers');
      if (!tiers) return;
      const isAdd =
        button.closest('product-form-component') || button.closest('sticky-add-to-cart-component, .sticky-add-to-cart');
      if (isAdd && (button.type === 'submit' || button.name === 'add' || button.closest('.sticky-add-to-cart, sticky-add-to-cart-component'))) {
        applyQty(tiers.dataset.sectionId);
      }
    },
    true
  );

  /* ---------- Estimation de livraison en jours ouvrés ---------- */
  const addBusinessDays = (date, days) => {
    const d = new Date(date);
    let added = 0;
    while (added < days) {
      d.setDate(d.getDate() + 1);
      const day = d.getDay();
      if (day !== 0 && day !== 6) added++;
    }
    return d;
  };
  const fmt = new Intl.DateTimeFormat('fr-FR', { weekday: 'short', day: 'numeric', month: 'short' });

  if (!customElements.get('douillet-eta')) {
    customElements.define(
      'douillet-eta',
      class extends HTMLElement {
        connectedCallback() {
          const min = Number(this.dataset.min);
          const max = Number(this.dataset.max);
          const line = this.querySelector('[data-dl-eta]');
          if (line && min > 0 && max >= min) {
            const now = new Date();
            line.innerHTML = `Livraison suivie estimée entre le <strong>${fmt.format(
              addBusinessDays(now, min)
            )}</strong> et le <strong>${fmt.format(addBusinessDays(now, max))}</strong>`;
          }
          const xmas = this.querySelector('[data-dl-xmas]');
          if (xmas && this.dataset.xmas) {
            const limit = new Date(`${this.dataset.xmas}T23:59:59`);
            if (!Number.isNaN(limit.getTime()) && new Date() <= limit) xmas.hidden = false;
          }
        }
      }
    );
  }

  /* ---------- Vignettes coloris sur les boutons de variante ---------- */
  const COLOR_NAMES = ['couleur', 'coloris', 'color'];
  const productCache = {};
  const loadProduct = (url) => {
    if (!productCache[url]) {
      productCache[url] = fetch(`${url.split('?')[0]}.js`, { headers: { Accept: 'application/json' } })
        .then((r) => (r.ok ? r.json() : null))
        .catch(() => null);
    }
    return productCache[url];
  };
  const decorateColors = async () => {
    const forms = document.querySelectorAll('[data-product-url]');
    for (const form of forms) {
      const url = form.dataset.productUrl;
      if (!url) continue;
      const product = await loadProduct(url);
      if (!product) continue;
      const colorIndex = product.options.findIndex((o) => COLOR_NAMES.includes(String(o.name || o).toLowerCase()));
      if (colorIndex < 0) continue;
      const images = {};
      product.variants.forEach((v) => {
        const value = v.options[colorIndex];
        if (!images[value] && v.featured_image) images[value] = v.featured_image.src;
      });
      document.querySelectorAll('input[type="radio"][data-option-name]').forEach((input) => {
        if (!COLOR_NAMES.includes(input.dataset.optionName.toLowerCase())) return;
        const label = input.closest('label');
        const src = images[input.value];
        if (!label || !src || label.querySelector('.dl-opt-thumb')) return;
        const img = document.createElement('img');
        img.className = 'dl-opt-thumb';
        img.alt = '';
        img.width = 32;
        img.height = 32;
        img.loading = 'lazy';
        img.src = `${src}${src.includes('?') ? '&' : '?'}width=96`;
        const text = label.querySelector('.variant-option__button-label__text');
        label.insertBefore(img, text || null);
      });
    }
  };
  let decorateTimer;
  const scheduleDecorate = () => {
    clearTimeout(decorateTimer);
    decorateTimer = setTimeout(decorateColors, 60);
  };
  if (document.querySelector('[data-product-url]')) {
    decorateColors();
    new MutationObserver(scheduleDecorate).observe(document.body, { childList: true, subtree: true });
  }

  /* ---------- Neige légère (canvas, pause hors écran, réduite sur mobile) ---------- */
  const initSnow = (host) => {
    if (reduceMotion || host.dataset.dlSnowReady) return;
    host.dataset.dlSnowReady = '1';
    const canvas = document.createElement('canvas');
    canvas.className = 'dlx-snow';
    canvas.setAttribute('aria-hidden', 'true');
    host.prepend(canvas);
    const ctx = canvas.getContext('2d');
    const dpr = Math.min(window.devicePixelRatio || 1, 2);
    let w = 0, h = 0, flakes = [], raf = 0, running = false;
    const make = (anywhere) => ({
      x: Math.random() * w,
      y: anywhere ? Math.random() * h : -6,
      r: Math.random() * 1.7 + 0.5,
      s: Math.random() * 0.45 + 0.2,
      d: Math.random() * 0.5 - 0.25,
      o: Math.random() * 0.45 + 0.2,
    });
    const resize = () => {
      w = host.clientWidth;
      h = host.clientHeight;
      canvas.width = w * dpr;
      canvas.height = h * dpr;
      canvas.style.width = `${w}px`;
      canvas.style.height = `${h}px`;
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      const count = window.innerWidth < 750 ? 26 : 64;
      flakes = Array.from({ length: count }, () => make(true));
    };
    const tick = () => {
      ctx.clearRect(0, 0, w, h);
      for (const f of flakes) {
        f.y += f.s;
        f.x += f.d + Math.sin(f.y / 45) * 0.12;
        if (f.y > h + 6 || f.x < -6 || f.x > w + 6) Object.assign(f, make(false));
        ctx.beginPath();
        ctx.arc(f.x, f.y, f.r, 0, Math.PI * 2);
        ctx.fillStyle = `rgba(255,250,244,${f.o})`;
        ctx.fill();
      }
      raf = requestAnimationFrame(tick);
    };
    resize();
    let resizeTimer;
    window.addEventListener('resize', () => { clearTimeout(resizeTimer); resizeTimer = setTimeout(resize, 200); }, { passive: true });
    new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting && !running) { running = true; tick(); }
      else if (!entry.isIntersecting && running) { running = false; cancelAnimationFrame(raf); }
    }).observe(host);
  };

  /* ---------- Profondeur du produit à la souris (desktop uniquement) ---------- */
  const initTilt = (stage) => {
    if (reduceMotion || stage.dataset.dlTiltReady) return;
    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    const section = stage.closest('[data-dl-parallax="true"]');
    if (!section) return;
    stage.dataset.dlTiltReady = '1';
    let frame = 0, tx = 0, ty = 0;
    const apply = () => {
      stage.style.setProperty('--dl-tx', tx.toFixed(3));
      stage.style.setProperty('--dl-ty', ty.toFixed(3));
      frame = 0;
    };
    section.addEventListener('pointermove', (event) => {
      const r = stage.getBoundingClientRect();
      tx = Math.max(-1, Math.min(1, (event.clientX - (r.left + r.width / 2)) / (r.width / 1.2)));
      ty = Math.max(-1, Math.min(1, (event.clientY - (r.top + r.height / 2)) / (r.height / 1.2)));
      if (!frame) frame = requestAnimationFrame(apply);
    }, { passive: true });
    section.addEventListener('pointerleave', () => { tx = 0; ty = 0; if (!frame) frame = requestAnimationFrame(apply); });
  };

  const initScene = (scope = document) => {
    scope.querySelectorAll('[data-dl-snow="true"]').forEach(initSnow);
    scope.querySelectorAll('[data-dl-stage]').forEach(initTilt);
  };
  initScene();
  // Éditeur de thème : ré-initialise une section rechargée
  document.addEventListener('shopify:section:load', (event) => initScene(event.target));

  /* ---------- Feedback panier : petit rebond de l'icône à l'ajout ---------- */
  document.addEventListener('cart:update', () => {
    if (reduceMotion) return;
    document.querySelectorAll('cart-icon, .header-actions__cart-icon').forEach((icon) => {
      icon.classList.remove('dl-bump');
      void icon.offsetWidth;
      icon.classList.add('dl-bump');
    });
  });
})();
